var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GameScreen',{attrs:{"question":_vm.question}},[void 0,_vm._v(" "),_c(_vm.question.type,{tag:"component",attrs:{"question":_vm.question}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }